"use client";

import { styled } from "styled-components";

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;

  border-bottom: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
`;

export const TableHeaderCell = styled.div<{
  $minWidth?: string;
  $maxWidth?: string;
}>`
  display: flex;
  min-width: ${({ $minWidth }) => $minWidth};
  max-width: ${({ $maxWidth }) => $maxWidth};
  padding: var(--Spacing-6, 0.6rem) var(--Spacing-4, 0.4rem);
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  flex: 1 0 0;

  background: var(--Color-Common-Bg-Secondary, #f0f2f4);

  border-right: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);

  &:last-child {
    border-right: none;
  }
`;

export const TableHeaderValue = styled.div`
  display: flex;
  padding: var(--Spacing-2, 0.2rem) var(--Spacing-6, 0.6rem);
  align-items: flex-start;
  gap: var(--Spacing-2, 0.2rem);
  flex: 1 0 0;

  color: var(--Color-Common-Text-Primary, #2a2f37);

  font-family: var(--font-pt-serif);
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 130%;
`;
